<template>
	<div id="Register" class="fullscreen-centered usually-on-top dark-stars">
		<div>
			<Logo/>
			<div v-if="isCheckingScanner" class="loading-message loading-dots">Loading</div>
			<div v-if="!isCheckingScanner">
				<div class="button-row">
					<div class="scanCamera" v-if="showReader">
						<qrcode-stream  @init="onInit" class="mb-3" v-if="showReader" @decode="onDecode">
							<div class="loading-indicator" v-if="loading">
								Loading Camera  <loading-dots color="#fff"/>
							</div>
						</qrcode-stream>
					</div>
					<div v-bind:class="{ hide: !register }"><form method="post" action="/" v-on:submit="registerScanner"><input id="registerInput" type="text" v-model="checkKey" />
						<button id="registerButton" v-on:click="showHideReader"><i class="fas fa-qrcode"></i></button></form>
					</div>
					<div v-bind:class="{ hide: register }"><button id="installButton" v-on:click="showRegister" class="better-mobile-btn green">
						<i class="fas fa-qrcode"></i> Register Scanner</button>
					</div>
				</div>
<!--				<div class="extraBtns" v-bind:class="{ hide: register }"><button id="installButton" class="better-mobile-btn"><i class="fas fa-mobile-alt"></i> Install App</button></div>-->
			</div>
		</div>
	</div>
</template>

<script>
	import axios from 'axios';
	import { QrcodeStream } from 'vue-qrcode-reader'
	import LoadingDots from "./icons_svg/LoadingDots.vue";
	import Logo from "./Logo.vue";

	export default {
		name: 'Register',
		components: {
			LoadingDots,
			QrcodeStream,
			Logo
		},
		data() {
			return {
				register: false,
				checkKey: '',
				showReader: false,
				element: null,
				loading: false,
				isCheckingScanner: true,
			}
		},
		mounted() {
			this.$scanner.checkScanner = this.checkScanner
			this.$scanner.registerScanner = this.registerScanner

			this.checkScanner()
		},
		methods: {
			showRegister() {
				this.register = true;
				this.showReader = true;
			},
	 		onDecode (decodedString) {
				this.checkKey = decodedString;
				this.registerScanner(this.element);
			},
			showHideReader(e) {
				if (!this.checkKey) {
					this.showReader = !this.showReader;
					this.element = e;
					if (e) { e.preventDefault(); }
				} else {
					this.showReader = false;
					this.registerScanner(e);
				}
			},
			async onInit(promise) {
				this.loading = true;
				// eslint-disable-next-line no-empty
				try {
					await promise
					// eslint-disable-next-line no-empty
				} catch (error) {
				} finally {
					this.loading = false;
				}
			},
			registerScanner(e) {
				if (e) { e.preventDefault(); }
				const empty = window.helpers.empty;
				window.debug('📱Scanner: Starting Registration');
				window.scanner.loader.open()
				// if (window.helpers.isFunction(this.$scanner.setRegistered)) { this.$scanner.setRegistered() }
				axios.defaults.headers.common['X-Auth-Token'] = process.env.VUE_APP_MS_AUTH_TOKEN;
				axios.post(`${this.$scanner.api_server}/api/scannerdevice/register`, {
					regkey: `${this.checkKey}`,
				})
				.then(res => {
					if (res.data.status.success) {
						window.debug('📱Scanner: ✅Successfully Registered.');
						window.debug(res.data.data);
						const data = res.data.data;
						if (!empty(data.registered) && data.registered == true) {
							// Auto reload party if exists
							if (data.has_active_party) {
								this.$emit('setHasActiveParty');
							}

							localStorage.setItem('scanner_regkey', data.token);
							window.debug('🗄DataStore: 📱Scanner Saved');
							const scanner = JSON.parse(data.scanner)
							const users = JSON.parse(data.users)
							if (!empty(scanner.title)) {
								localStorage.setItem('scanner_title', scanner.title)
								window.debug('🗄DataStore: 📱Scanner Title Saved')
							} else {
								localStorage.removeItem('scanner_title')
								window.debug('🗄DataStore: 📱Scanner Title Removed')
							}
							if (!empty(users) && Array.isArray(users)) {
								[1,2,3,4,5,6,7,8].forEach(function(userSlot) {
									localStorage.removeItem(`scanner_user_0${userSlot}_id`)
									localStorage.removeItem(`scanner_user_0${userSlot}_name`)
									localStorage.removeItem(`scanner_user_0${userSlot}_photo`)
									window.debug('🗄DataStore: 📱Scanner Users Removed')
								});
								let userNumber = 0
								users.forEach(function(user) {
									++userNumber;
									localStorage.setItem(`scanner_user_0${userNumber}_id`, user.id)
									localStorage.setItem(`scanner_user_0${userNumber}_name`, `${user.first_name} ${user.last_name}`)
									localStorage.setItem(`scanner_user_0${userNumber}_photo`, user.thumbnail)
									window.debug(`🗄DataStore: 📱Scanner User Saved: ${user.first_name} ${user.last_name}`)
								});
								localStorage.setItem('scanner_user_count', userNumber)
							} else {
								window.refresh()
							}
							this.register = false
							if (window.helpers.isFunction(this.$scanner.setRegistered)) { this.$scanner.setRegistered() }
							window.scanner.loader.close()
						} else {
							localStorage.removeItem('scanner_regkey');
							window.debug('🗄DataStore: 📱Scanner Removed');
							this.register = true
							if (window.helpers.isFunction(this.$scanner.setUnregistered)) { this.$scanner.setUnregistered() }
							window.scanner.loader.close()
							window.scanner.message.send('Not Found','Scanner Not Found',true)
						}
					} else {
						window.debug('📱Scanner: 🚫Not Registered');
						window.debug(res.data.data);
						this.register = true
						if (window.helpers.isFunction(this.$scanner.setUnregistered)) { this.$scanner.setUnregistered() }
						window.scanner.loader.close()
						window.scanner.message.send('Not Found','Scanner Not Found',true)
					}
				})
				.catch(err => {
					window.debug('📱Scanner: 🚫Error Connecting to Server');
					window.debug(err);
					window.scanner.message.send('Not Found','Error Connecting Server',true)
				});
				window.debug('📱Scanner: Finished Loading Fresh Data');
				this.checkKey = '';
				this.showReader = false;
				window.scanner.loader.close()
				return false;
			},
			checkScanner() {
				this.isCheckingScanner = true;
				const empty = window.helpers.empty;
				window.debug('📱Scanner: Checking Scanner');
				if (!empty(localStorage.getItem('scanner_regkey'))) {
					axios.defaults.headers.common['X-Auth-Token'] = localStorage.getItem('scanner_regkey');
					axios.post(`${this.$scanner.api_server}/api/scannerdevice/check`, {
						check: `${localStorage.getItem('scanner_regkey')}`,
					})
					.then(res => {
						if (res.data.status.success) {
							window.debug('📱Scanner: ✅Successfully Checked.');
							window.debug(res.data.data);
							const data = res.data.data;
							if (!empty(data.checked) && data.checked === true) {
								this.register = true
								if (window.helpers.isFunction(this.$scanner.setRegistered)) { this.$scanner.setRegistered() }
								window.debug('🗄DataStore: 📱Scanner Recovered');
								window.scanner.loader.close()
							} else {
								window.debug('🗄DataStore: 📱Scanner Removed');
								this.register = true
								if (window.helpers.isFunction(this.$scanner.setUnregistered)) { this.$scanner.setUnregistered() }
								window.scanner.loader.close()
							}
							window.scanner.loader.close()
						} else {
							window.debug('📱Scanner: 🚫Check Failed');
							window.debug(res.data.data);
							window.scanner.loader.close()
						}
					})
					.catch(err => {
						window.debug('📱Scanner: 🚫Error Connecting to Server for Scanner Check');
						window.debug(err);
						window.scanner.loader.close()
						this.$scanner.message.send('Check Connection','Issue connecting to server.',false)
					})
					.finally(() => {
						this.isCheckingScanner = false;
					});
					window.debug('📱Scanner: Finished Scanner Check');
				} else {
					//window.scanner.loader.close()
					window.debug('🗄DataStore: 📱Scanner Not Found');

					this.isCheckingScanner = false;
				}
			},
		}
	}
</script>

<style scoped>
.loading-indicator {
	font-weight: bold;
	margin-top: 200px;
	font-size: 2rem;
	text-align: center;
}

.scanCamera {
	max-height: 30em;
	max-width: 20em;
	margin: 0 auto;
}
</style>

<style>
	#Register {  }
	/* #registerInput { width: 146px; height: 25px; padding: 5px 10px; margin: 2px; } */
</style>